import React from 'react';
import { shallowEqual } from 'react-redux';
import { rtDebug } from '..';
import { useAppSelector } from '../../../../../hooks/hooks';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import useRenderDebug from '../../../../../hooks/useRenderDebug';
import FiltersRender from './FiltersRender';

const Additional = ({ tableName }: { tableName?: string }) => {
  const { name } = useResponsiveTableContext(tableName);

  const additionalFilters = useAppSelector((global) => {
    const state = global.responsiveTableSlice[name];
    return state?.filters.filter(
      (current) =>
        ['entitySpecific', undefined].includes(current.group) &&
        ((!current.isMeta &&
          !state?.columns.find(
            (search) => search.name === current.column && !current.asAdditional,
          )) ||
          state?.columns.find(
            (search) =>
              search.name === current.column && search.showAsAdditional,
          ) ||
          current.asAdditional),
    );
  }, shallowEqual);
  useRenderDebug(rtDebug.filters.additional, 'Additional.tsx', {
    name,
    additionalFilters,
  });

  return (
    <FiltersRender className="additionalFilters" filters={additionalFilters} />
  );
};

export default React.memo(Additional);
